// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { Avatar } from '@mui/material';

const DEFAULT_VARIANT = 'circular';

/**
 * SolyticsAvatar - Wrapper around MUI Avatar
 *
 * @param {string} alt - Alt text for image avatars
 * @param {string} src - Image source URL
 * @param {string} srcSet - Image srcSet value
 * @param {React.ReactNode} children - Fallback content (initials/icon)
 * @param {string} variant - Avatar shape: 'circular' | 'rounded' | 'square'
 * @param {string|number} size - Shorthand to set both width and height
 * @param {string|number} width - Avatar width
 * @param {string|number} height - Avatar height
 * @param {string|number} minWidth - Minimum width
 * @param {string|number} maxWidth - Maximum width
 * @param {string|number} minHeight - Minimum height
 * @param {string|number} maxHeight - Maximum height
 * @param {string|number} fontSize - Font size for fallback content
 * @param {string} bgcolor - Background color
 * @param {string} color - Text/icon color
 * @param {string|number} border - Border value (e.g. '2px solid #fff')
 * @param {function} onClick - Click handler
 * @param {object|Array|function} sx - Additional sx overrides
 */
const SolyticsAvatar = React.forwardRef(
  (
    {
      alt,
      src,
      srcSet,
      children,
      variant = DEFAULT_VARIANT,
      size,
      width,
      height,
      minWidth,
      maxWidth,
      minHeight,
      maxHeight,
      fontSize,
      bgcolor,
      color,
      border,
      onClick,
      id,
      title,
      className,
      imgProps,
      sx,
    },
    ref
  ) => {
    const resolvedWidth = width ?? size;
    const resolvedHeight = height ?? size;

    return (
      <Avatar
        ref={ref}
        {...(alt !== undefined && { alt })}
        {...(src !== undefined && { src })}
        {...(srcSet !== undefined && { srcSet })}
        {...(variant !== undefined && { variant })}
        {...(onClick !== undefined && { onClick })}
        {...(id !== undefined && { id })}
        {...(title !== undefined && { title })}
        {...(className !== undefined && { className })}
        {...(imgProps !== undefined && { imgProps })}
        sx={[
          resolvedWidth !== undefined && { width: resolvedWidth },
          resolvedHeight !== undefined && { height: resolvedHeight },
          minWidth !== undefined && { minWidth },
          maxWidth !== undefined && { maxWidth },
          minHeight !== undefined && { minHeight },
          maxHeight !== undefined && { maxHeight },
          fontSize !== undefined && { fontSize },
          bgcolor !== undefined && { bgcolor },
          color !== undefined && { color },
          border !== undefined && { border },
          sx,
        ]}
      >
        {children}
      </Avatar>
    );
  }
);

SolyticsAvatar.displayName = 'SolyticsAvatar';

export default memo(SolyticsAvatar);
